import {useState} from "react";
import {PageHeader} from "../../../components/PageHeader";
import HistoryListType from "../../settings/history/subPages/HistoryListType";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../hooks/useRequestData";
import {getHistoryList} from "../../../api/history/HistoryService";
import {ASSET_HISTORY_LIST_HEADER} from "../../../components/table/header/Headers";

function AssetHistoryList() {
    const [checked,setChecked] = useState([]);
    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }
    const type = "asset_history"
    const { data, pageInfo, getQr, newData, dataHook} =
        useRequestData((conditions, pageable) => {
            const additionalCondition = {
                entityName: "자산관리",
                historyType: conditions.historyType || 'A'
            };
            const finalConditions = {
                ...conditions,
                ...additionalCondition
            };
            return getHistoryList(finalConditions, pageable);
        }, initDate, type);
    return (
        <>
            <div className="common-container">
                <PageHeader header={"자산이력정보"} indicator={"자산관리 > 자산종합관리 > 자산이력정보"} />
                <HistoryListType checked={{checked: checked, setChecked: setChecked}}
                                 data={newData} date={initDate} pageInfo={pageInfo}
                                 dataHook={dataHook}
                                 getQr={getQr}
                                 header={ASSET_HISTORY_LIST_HEADER}
                                 type={type}
                />
            </div>
        </>
    );
}

export default AssetHistoryList;